export default {
  // Configuración general de la tienda (uso común)
  storeSettings: {
    logoType: 'square', // Personalización para lenceria-gabrieles
    storeName: 'lenceria-gabrieles',
    currency: 'MXN',
    language: 'es',
    timezone: 'America/Mexico_City'
  },
  
  // Configuración específica del componente Cart
  Cart: {
    // Campos obligatorios en el formulario de pedido
    requiredFields: {
      nombre: true,
      email: false,
      telefono: true,
      direccion: true, // Solo obligatorio si es delivery
    },
    
    // Opciones de entrega disponibles
    deliveryOptions: [
      {
        id: 'Envio',
        label: 'Envío Gratis a domicilio',
        price: 0, // Precio en centavos o la unidad que uses
        default: false
      },
      {
        id: 'Recoger',
        label: 'Recoger Gratis en tienda',
        price: 0,
        default: true
      }
    ],
    
    // Configuración de métodos de pago
    paymentMethods: [
      {
        id: 'efectivo',
        label: 'Efectivo',
        default: true
      },
      {
        id: 'transferencia',
        label: 'Transferencia bancaria',
        default: false
      }
    ]
  },
  
  // Configuración específica del componente Navbar
  Navbar: {
    showSearch: true,
    showCart: true,
    showProfile: true,
    logoPosition: 'left' // 'left', 'center', 'right'
  },
  
  // Configuración específica del componente Products
  Products: {
    itemsPerPage: 12,
    showFilters: true,
    showSorting: true,
    gridColumns: 3 // Número de columnas en la grilla
  },
  
  // Configuración específica del componente Footer
  Footer: {
    showSocialMedia: true,
    showContactInfo: true,
    showNewsletter: false
  },
  
  // Configuración específica del catálogo
  Catalog: {
    showCategories: true,
    showFilters: true,
    itemsPerPage: 20,
    gridColumns: 4
  }
};